import { createApp } from 'vue';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { Network } from '@capacitor/network';
import { PushNotifications } from '@capacitor/push-notifications';
import { SafeArea } from 'capacitor-plugin-safe-area';
import * as Sentry from "@sentry/browser";

import App from './App.vue';
import router from './utils/router.js';
import store from './utils/store.js';
import mixin from './utils/mixin.js';

import 'mapbox-gl/dist/mapbox-gl.css';
import './assets/styles.css';
import './assets/ionicons.min.css';

const app = createApp(App)
  .use(router)
  .use(store);

Sentry.init({
  dsn: store.state.dsn,
  integrations: [],
  tracesSampleRate: 0,
});

app.config.errorHandler = (err, vm, info) => {
  Sentry.captureException(err, {
    extra: {
      component: vm.$options.name,
      info,
    },
  });
};

window.onerror = function (message, source, lineno, error) {
  Sentry.captureException(error, {
    extra: {
      message,
      source,
      lineno,
    },
  });
};

window.addEventListener("unhandledrejection", function (event) {
  Sentry.captureException(event.reason, {
    extra: {
      reason: event.reason?.message || event.reason,
      promise: event.promise,
      type: event.type,
      time: new Date().toISOString(),
    },
  });
});

app.mount('#app');

Network.addListener('networkStatusChange', status => {
  store.state.isOnline = status.connected;
});

Device.getInfo().then(details => {
  store.state.platform = details.platform;
  store.state.deviceInfo = details;

  let ua = navigator.userAgent;
  if (ua.match(/chrome|chromium|crios/i)) store.state.browser = 'Chrome';
  else if(ua.match(/firefox/i)) store.state.browser = 'Firefox';
  else if(ua.match(/safari/i) && !ua.match(/chrome|chromium|crios/i)) store.state.browser = 'Safari';
  else if(ua.match(/opr\//i)) store.state.browser = 'Opera';
  else if(ua.match(/edg/i)) store.state.browser = 'Edge';
  else store.state.browser = 'Unknown';
});

if (Capacitor.isNativePlatform()) {
  if (Capacitor.isPluginAvailable('Share')) store.state.canShare = true;

  SafeArea.enable({config: {}});

  function handleNotification(notification, type = 'Clicked') {
    mixin.methods.sendBeacon('Push Notification', type, notification);

    if (type == 'Clicked' && notification.notification['data']) {
      let d = notification.notification['data'];
      if (d.type == 'external') window.open(d.url, '_system');
      else if (d.type == 'internal') router.push(d.url);
    }
  }

  PushNotifications.requestPermissions().then(result => {
    if (result.receive === 'granted') {
      PushNotifications.register();
    } else {
      alert('You wont receive crucial notifications from Uzhavarbumi!');
    }
  });

  PushNotifications.addListener('registration', token => {
    window.localStorage.setItem('dealer_fcm_token', token.value);
  });

  PushNotifications.addListener('pushNotificationActionPerformed', notification => {
    handleNotification(notification, 'Clicked');
  });

  PushNotifications.addListener('pushNotificationReceived', notification => {
    handleNotification(notification, 'Auto Opened');
  });
}
